import React, { useState } from "react";
//import AllPrograms from '../components/AllPrograms/AllPrograms';

import Aside from "../modules/SideNav/Aside";

function AllProgramsLayout() {
  const rtl = false;

  const [toggled, setToggled] = useState(false);

  const handleToggleSidebar = (value) => {
    setToggled(value);
  };

  return (
    <>
      {/* <Aside
        rtl={rtl}
        toggled={toggled}
        handleToggleSidebar={handleToggleSidebar}
      /> */}
      {/*  <AllPrograms handleToggleSidebar={handleToggleSidebar} /> */}
    </>
  );
}

export default AllProgramsLayout;
